import { endOfDay, startOfDay } from "date-fns";
import { z } from "zod";

export const proofOfEarningsSchema = z
  .object({
    start: z.date().transform((date) => startOfDay(date)),
    end: z.date().transform((date) => endOfDay(date)),
  })
  .superRefine((data, context) => {
    if (data.end < data.start) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: "End date must be after start date",
        path: ["end"],
      });
    }

    const endOfToday = endOfDay(new Date());
    if (data.end > endOfToday) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: "End date cannot be after today",
        path: ["end"],
      });
    }
  });

export type ProofOfEarningsFormValues = z.infer<typeof proofOfEarningsSchema>;
